export const config = {
  eventGroup: 'jxsj_xfyy_pc_20260924',
  name: '《剑侠世界》端游26年10月新服预约专题PC端',
  identify: 'jxsj2',
  eventTags: ['jxsj', 'pc']
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    clickGoGuanwang: function() {
      report({
        eventName: 'click_go_guanwang',
        eventDescription: '进入官网'
      });
    },
    clickGoDownload: function() {
      report({
        eventName: 'click_go_download',
        eventDescription: '下载游戏'
      });
    },
    clickGoSpecial: function() {
      report({
        eventName: 'click_go_special',
        eventDescription: '资料片专题'
      });
    },
    /**
     * @param {string} [title] - 导航栏名称：新服预约、特惠礼包、生态专属、活动说明、返回顶部、送云游时长
     */
    clickNav: function(title) {
      report({
        eventName: 'click_nav',
        eventDescription: '点击导航栏',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickSubscribe: function() {
      report({
        eventName: 'click_subscribe',
        eventDescription: '立即预约'
      });
    },
    /**
     * @param {string} [title] - 上报不同的礼包
     */
    clickBuyGoods: function(title) {
      report({
        eventName: 'click_buy_goods',
        eventDescription: '我要购买',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickIdentityValidate: function() {
      report({
        eventName: 'click_identity_validate',
        eventDescription: '身份验证'
      });
    },
    clickBindPhone: function() {
      report({
        eventName: 'click_bind_phone',
        eventDescription: '去绑定手机'
      });
    },
    clickHaveBindPhone: function() {
      report({
        eventName: 'click_have_bind_phone',
        eventDescription: '我已绑定手机'
      });
    },
    clickCreateTeam: function() {
      report({
        eventName: 'click_create_team',
        eventDescription: '创建购买队伍'
      });
    },
    clickUrlBuy: function() {
      report({
        eventName: 'click_url_buy',
        eventDescription: '复制专属链接'
      });
    },
    /**
     * @param {string} [nameId] - 邀请码
     */
    clickJoinTeam: function(nameId) {
      report({
        eventName: 'click_join_team',
        eventDescription: '加入购买队伍',
        eventDataValue: {
          name_id: nameId
        },
        types: {
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [nameId] - 邀请码
     */
    clickCreateTeamLink: function(nameId) {
      report({
        eventName: 'click_create_team_link',
        eventDescription: '创建购买队伍',
        eventDataValue: {
          name_id: nameId
        },
        types: {
          name_id: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [nameId] - 邀请码
     */
    clickSubscribeLink: function(nameId) {
      report({
        eventName: 'click_subscribe_link',
        eventDescription: '立即预约',
        eventDataValue: {
          name_id: nameId
        },
        types: {
          name_id: checkTypeHOF('string')
        }
      });
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
